export default "__VITE_ASSET__BUcH3m_K__"